import { IconSquareRotatedFilled } from "@tabler/icons-react";

import { IconCheck } from "@/components/icons";

export function getRenderIcon(passwordTouched: boolean) {
  return (met: boolean) =>
    met ? (
      <IconCheck size={12} style={{ color: "var(--mantine-color-success-7)" }} />
    ) : (
      <IconSquareRotatedFilled
        size={12}
        style={{
          color: !passwordTouched ? "var(--mantine-color-text)" : "var(--mantine-color-danger-7)",
          transition: "color 0.2s ease, opacity 0.2s ease",
        }}
      />
    );
}
